import React from 'react'

const AzimEmoji1Svg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 12.847 12.847'
    >
      <g id='emoji-nerd-svgrepo-com' transform='translate(-1 -1)'>
        <path
          id='Path_3137'
          data-name='Path 3137'
          d='M7.323,13.062a.584.584,0,0,1,.78.254,1.505,1.505,0,0,0,.357.4,2.258,2.258,0,0,0,1.46.456,2.258,2.258,0,0,0,1.46-.456,1.506,1.506,0,0,0,.357-.4.584.584,0,0,1,1.041.53,2.042,2.042,0,0,1-.173.271,2.823,2.823,0,0,1-.495.507,3.419,3.419,0,0,1-2.19.712,3.419,3.419,0,0,1-2.19-.712,2.823,2.823,0,0,1-.495-.507,1.816,1.816,0,0,1-.174-.272A.584.584,0,0,1,7.323,13.062Z'
          transform='translate(-2.496 -4.993)'
          fill='#e15226'
        />
        <path
          id='Path_3138'
          data-name='Path 3138'
          d='M13.847,7.423A6.423,6.423,0,1,1,7.423,1,6.423,6.423,0,0,1,13.847,7.423Zm-11.675,0A5.251,5.251,0,1,0,12.3,5.461l-.817.544a1.752,1.752,0,0,1-3.372.25H6.74a1.752,1.752,0,0,1-3.372-.25l-.817-.544A5.237,5.237,0,0,0,2.172,7.423Zm.937-2.994.487.324a1.752,1.752,0,0,1,3.144.334H8.107a1.752,1.752,0,0,1,3.144-.334l.487-.324a5.253,5.253,0,0,0-8.629,0ZM4.417,5.672A.67.67,0,1,0,5.088,5,.67.67,0,0,0,4.417,5.672Zm5.342.67a.67.67,0,1,1,.67-.67A.67.67,0,0,1,9.759,6.342Z'
          fill='#e15226'
          fillRule='evenodd'
        />
      </g>
    </svg>
  )
}

export default AzimEmoji1Svg
